export const AttachmentSourceMapping = {
    Native: "NATIVE",
    OneDrive: "ONE_DRIVE",
};
